import Badge from '@theme/components/Badge/src/jsx/Badge';

export const getBadge = (data, getLabel) => {
	if (data.required) {
		return <Badge name={getLabel('package_required')} />;
	} else if (data.included) {
		return <Badge name={getLabel('package_included')} />;
	} else if (data.recommended) {
		return <Badge name={getLabel('package_recommended')} />;
	} else {
		return null;
	}
};
